import { prefixerC } from '.'

export const ROUTE_DIARIO_APERTURA = prefixerC('diario-apertura')
export const ROUTE_PERMISOS_ADMINISTRACION = prefixerC('permisos-administracion')
export const ROUTE_PERMISOS_TRANSACCIONES = prefixerC('permisos-transacciones')
export const ROUTE_CREAR_PLAN_CUENTA = prefixerC('crear-plan-cuenta')
export const ROUTE_ASIGNACION_PERMISOS = prefixerC('asignacion-permisos')
